import { IBrokerAvailability } from '../../types/brokerAvailability';

const initialState: IBrokerAvailability = {
  accountLegalType: undefined,
  hasConfirmedPhone: false,
  partnerRewardsRegistrationStatus: undefined,
};

export const brokerAvailabilityReducer = (state: IBrokerAvailability = initialState): IBrokerAvailability => state;
